export enum adminScoutApplicantsTypes {
    FETCH_ADMIN_SCOUT_APPLICANTS_SUCCESS = "FETCH_ADMIN_SCOUT_APPLICANTS_SUCCESS",
    FETCH_ADMIN_SCOUT_APPLICANTS_REQUEST = "FETCH_ADMIN_SCOUT_APPLICANTS_REQUEST",
    FETCH_ADMIN_SCOUT_APPLICANTS_FAILURE = "FETCH_ADMIN_SCOUT_APPLICANTS_FAILURE",

}